import { useMutation } from 'react-query'

import { APIError, APIResponse } from '../../../utils'
import { updateContactFieldsById } from '../query-api'
import { Contact } from '../types/contact'

interface UseUpdateContactFieldsByIdProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: APIResponse<Contact>) => void
}

export interface UpdateContactFieldsByIdProps {
  id: string
  fields: Partial<Contact>
}

export const useUpdateContactFieldsById = (props?: UseUpdateContactFieldsByIdProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: update,
    isLoading: isProcessing,
    ...rest
  } = useMutation(({ id, fields }: UpdateContactFieldsByIdProps) => updateContactFieldsById(id, fields), {
    onSuccess,
    onError,
  })

  return { update, isProcessing, ...rest }
}
